import React, { memo, useEffect } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import FailedImage from 'src/assets/images/failed.png'
import { ClientPublicWrapper } from 'src/components/layout/client/ClientPublicWrapper'
import { useDispatch, useSelector } from 'react-redux'
import { LoadingPage } from './LoadingPage'
import { FetchDriver } from 'src/constants/actionTypes'
import { getPartner } from 'src/selectors/partner'

const OnboardingFailedPageComponent = () => {
  const dispatch = useDispatch()

  const partner = useSelector(getPartner)

  useEffect(() => {
    window.parent.postMessage(
      {
        type: 'onboarding_failed',
      },
      '*',
    )

    if (partner) {
      return
    }

    dispatch(FetchDriver.request())
  }, [])

  if (!partner) {
    return <LoadingPage flow="client" />
  }

  return (
    <ClientPublicWrapper>
      <div css={tw`h-full flex flex-col justify-between px-4`}>
        <img src={FailedImage} css={tw`h-[220px] w-[280px] self-center`} />
        <div>
          <Typography css={tw`my-4 text-center`} variant="h2">
            Onboarding failed
          </Typography>
          <Typography css={tw`text-center  text-shades-400`}>
            {`We regret to inform you that your onboarding process with ${partner?.displayName} did not meet their required standards.`}
          </Typography>
        </div>
      </div>
    </ClientPublicWrapper>
  )
}

export const OnboardingFailedPage = memo(OnboardingFailedPageComponent)
